import { React, useEffect, useState } from "react";
import { HiOutlineArrowLeftCircle } from "react-icons/hi2";
import { RxHamburgerMenu } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { selectUiControl, selectUserData } from "../../features/store";
import { Tooltip } from "@mui/material";
import { setOpenVerticalNavBar } from "../../features/slices/uiControlSlice";
const VerticalNavBar = ({ vbData }) => {
    const [selected, setSelected] = useState(-1);
    const userData = useSelector(selectUserData);
    const uiControl = useSelector(selectUiControl);
    const dispatch = useDispatch();
    const toggleSidebar = () => dispatch(setOpenVerticalNavBar(!uiControl.openVerticalNavBar));
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setSelected(location.pathname);
    }, [location.pathname]);
    return (
        <>
            <div
                className={`navbarBackground ${uiControl.openVerticalNavBar ? "expanded" : "closed"}`}
                onClick={toggleSidebar}
            ></div>
            <div className={`nav-menu ${uiControl.openVerticalNavBar ? "expanded" : "closed"}`}>
                <div className={`nav-menu-items ${uiControl.openVerticalNavBar ? "expanded" : "closed"}`}>
                    {vbData.map((item, index) => {
                        let hasAccess = item.permissions.includes(userData.permission);
                        if (hasAccess) {
                            return (
                                <div
                                    key={"navItem" + item.path}
                                    className={`itemWrapper ${selected === item.path ? "selected" : "deselect"} ${
                                        hasAccess ? "enable" : "disable"
                                    } `}
                                    onClick={() => {
                                        if (!hasAccess) return;
                                        setSelected(item.path);
                                        navigate(item.path);
                                    }}
                                >
                                    <div className={`nav-item ${uiControl.openVerticalNavBar ? "expanded" : "closed"}`}>
                                        <Tooltip
                                            title={
                                                !uiControl.openVerticalNavBar
                                                    ? `${item.title} ${hasAccess ? "" : " (Locked)"}`
                                                    : ""
                                            }
                                            arrow
                                            placement="right"
                                        >
                                            <div className="nav-icon">{item.icon}</div>
                                        </Tooltip>

                                        {uiControl.openVerticalNavBar && <p>{item.title}</p>}
                                    </div>
                                </div>
                            );
                        } else {
                            <></>;
                        }
                    })}

                    <div className="itemWrapper toggle enable">
                        <div
                            className="navbar-toggle nav-item"
                            onClick={toggleSidebar}
                            style={uiControl.openVerticalNavBar ? { width: 250 } : { width: 70 }}
                        >
                            {uiControl.openVerticalNavBar ? (
                                <HiOutlineArrowLeftCircle className="nav-icon" />
                            ) : (
                                <RxHamburgerMenu className="nav-icon" />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VerticalNavBar;
